import { Component, OnInit } from '@angular/core';
import {AuthenticationService} from '../../../services/authentication.service';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../../../../environments/environment';
import {ConfigurationService} from "../../../services/configuration.service";

@Component({
  selector: 'app-contact-us-generic',
  templateUrl: './contact-us-generic.component.html',
  styleUrls: ['./contact-us-generic.component.scss']
})
export class ContactUsGenericComponent implements OnInit {
  es = environment.es;
  constructor(
    private authenticationService: AuthenticationService,
    private translate: TranslateService,
    public configurationService: ConfigurationService
  ) { }

  ngOnInit(): void {
    this.configurationService.getPlatformConfig();
  }
  changeLanguage(language: string) {
    this.authenticationService.setLocale(language);
    this.translate.use(this.getValidLanguage(language));
  }
  getValidLanguage(language: string){
    if (language === 'es' || language === 'en'){
      return language;
    } else {
      return 'en';
    }
  }
}
